import { useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { getRestaurants } from "@/lib/store";
import { getRankingDefFromList } from "@/lib/rankings";

const RankingDetailPage = () => {
  const { key } = useParams<{ key: string }>();
  const list = useMemo(() => getRestaurants(), []);
  const def = useMemo(() => getRankingDefFromList(list, key || ''), [key, list]);
  const items = useMemo(() => (def ? def.compute(list) : []), [def, list]);

  if (!def) {
    return (
      <div className="min-h-screen grid place-items-center p-6">
        <div className="text-center">
          <div className="text-xl font-semibold mb-2">ランキングが見つかりません</div>
          <Link className="text-primary underline" to="/rankings">ランキング一覧へ</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background p-3 sm:p-4">
      <div className="container mx-auto max-w-4xl space-y-4">
        <div className="space-y-1">
          <Link className="text-sm text-primary underline" to="/rankings">ランキング一覧へ</Link>
          <h1 className="text-2xl font-bold tracking-tight">{def.title}</h1>
          <div className="text-sm text-muted-foreground">{def.description}</div>
        </div>
        <div className="space-y-2">
          {items.slice(0, 50).map((it, idx) => (
            <Link key={it.restaurant.id} to={`/view/${it.restaurant.id}`}>
              <Card className="grid gap-3 border-0 p-3 shadow-card transition hover:shadow-warm sm:grid-cols-[auto_1fr_auto] sm:items-center">
                <div className="grid h-10 w-10 place-items-center rounded-md bg-secondary text-sm font-semibold">{idx + 1}</div>
                <div className="min-w-0">
                  <div className="truncate font-medium">{it.restaurant.name}</div>
                  <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
                    <Badge variant="secondary">{it.restaurant.cuisine || '未分類'}</Badge>
                    <span>{it.restaurant.location}</span>
                  </div>
                </div>
                <div className="text-sm text-muted-foreground sm:text-right">
                  スコア <span className="text-lg font-semibold text-foreground">{Math.round(it.score * 10) / 10}</span>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RankingDetailPage;
